import { call, put, takeEvery } from "redux-saga/effects";
import type { PayloadAction } from "@reduxjs/toolkit";
import request from "../../../utils/request";
import { API_ENDPOINT } from "../../../utils/constants";
import { handleAxiosError } from "../../../utils/APIValidations";
import {
  saveRequestReset,
  requestResetSaved,
  requestResetSavingError,
  saveVerifyOtp,
  verifyOtpSaved,
  verifyOtpSavingError,
  saveResetPassword,
  resetPasswordSaved,
  resetPasswordSavingError,
} from "./slice";
import type {
  RequestResetPayload,
  ResetPasswordPayload,
  VerifyOtpPayload,
} from "./types";

function jsonOptions(payload: object): RequestInit {
  return {
    mode: "cors",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  };
}

export function* postRequestReset({
  payload,
}: PayloadAction<RequestResetPayload>) {
  const requestURL = `${API_ENDPOINT}request-password-reset`;
  try {
    yield call(request, requestURL, jsonOptions(payload));
    yield put(requestResetSaved());
  } catch (e) {
    yield call(handleAxiosError, e);
    yield put(requestResetSavingError());
  }
}

export function* postVerifyOtp({ payload }: PayloadAction<VerifyOtpPayload>) {
  const requestURL = `${API_ENDPOINT}verify-otp`;
  try {
    yield call(request, requestURL, jsonOptions(payload));
    yield put(verifyOtpSaved());
  } catch (e) {
    yield call(handleAxiosError, e);
    yield put(verifyOtpSavingError());
  }
}

export function* postResetPassword({
  payload,
}: PayloadAction<ResetPasswordPayload>) {
  const requestURL = `${API_ENDPOINT}reset-password`;
  try {
    yield call(request, requestURL, jsonOptions(payload));
    yield put(resetPasswordSaved());
  } catch (e) {
    yield call(handleAxiosError, e);
    yield put(resetPasswordSavingError());
  }
}

export default function* saga() {
  yield takeEvery(saveRequestReset.type, postRequestReset);
  yield takeEvery(saveVerifyOtp.type, postVerifyOtp);
  yield takeEvery(saveResetPassword.type, postResetPassword);
}
